import { Chips, Separator, TextInput, useTranslationContext } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { intersection } from 'ramda';
import { isEmptyArray } from 'ramda-adjunct';
import { suffixTestId } from 'shared/web';
import { quickFiltersConst } from '../../constants/quickFilters';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import type { EagFilterProps } from '../../types/EagFilterProps';
import { getFilterFieldName } from '../../utils/getFilterFieldName';
export type TextFilterProps = EagFilterProps & {
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function TextFilter(props: TextFilterProps) {
  const t = useTranslationContext();
  const model = props.value[FILTER_VALUE_KEY] as string | null ?? null;
  const onChange = (changeValue: string | null) => {
    props.onChange({
      [FILTER_VALUE_KEY]: changeValue
    });
  };
  const {
    onChipsChange
  } = useFilterOnChipsChange({
    setFilterValue: onChange,
    defaultValue: null
  });
  const isQuickFilterValue = intersection([model], quickFiltersConst) as string[];
  return <VStack>
      {props.quickFilters && props.quickFilters.length > 0 && <>
          <HStack>
            <Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId('text-filter-quickFilters', props)} isDeselectable />
          </HStack>
          <Separator />
        </>}
      <TextInput placeholder={t('page.datagrid.filter.textPlaceholder', {
      field: getFilterFieldName(props.column)
    })} value={isEmptyArray(isQuickFilterValue) ? model : null} onChange={onChange} isDisabled={props.isDisabled} data-testid={suffixTestId('text-filter', props)} />
    </VStack>;
}